module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(grupa)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.edit',
          params: {
            id: _vm.id
          }
        })
      }
    }
  }, [_vm._v("Edytuj grupę")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Grupa publiczna?\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.public ? 'Tak' : 'Nie'))])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Ilość subskrybentów\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.total_emails))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Status\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.status == 1 ? 'Aktywna' : 'Nie aktywna') + "\n              ")])]), _vm._v(" "), (_vm.item.id) ? _c('tr', [_c('th', [_vm._v("\n                  Konto\n              ")]), _vm._v(" "), _c('td', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.show',
          params: {
            id: _vm.item.email_account.id
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.item.email_account.name))])])]) : _vm._e()])]), _vm._v(" "), (_vm.item.id && _vm.item.public) ? _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Kod formularza do zapisywania się do tej grupy\n      ")]), _vm._v(" "), _c('p', [_vm._v("Element do umieszczenie w kodzie html strony tam gdzie chcemy aby pokazał się formularz")]), _vm._v(" "), _c('p', {
    staticClass: "template-pre"
  }, [_vm._v("\n          " + _vm._s(_vm.item.signup_form) + "\n      ")]), _vm._v(" "), _c('p', [_vm._v("Element do umieszczenie w kodzie html strony na samym dole przed końcem znacznika body")]), _vm._v(" "), _c('p', {
    staticClass: "template-pre"
  }, [_vm._v("\n          " + _vm._s(_vm.item.signup_script) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.item.id && _vm.item.public) ? _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Dane formularza do zapisywania się do tej grupy\n      ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "type": "flat"
    },
    on: {
      "click": _vm.openPreviewFormPage
    }
  }, [_vm._v("Podgląd formularza")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Tytuł formularza\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.form_title ? _vm.item.form_title : '—'))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Wymagana zgoda (1)\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.user_agree ? 'Tak' : 'Nie'))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Wymagana zgoda (2)\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.user_agree2 ? 'Tak' : 'Nie'))])])])])]) : _vm._e(), _vm._v(" "), (_vm.item.id && _vm.item.public) ? _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Wiadomość e-mail z linkiem potwierdzającym\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Dodatkowa treść\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.confirm_email_body ? _vm.item.confirm_email_body : '—'))])])])])]) : _vm._e(), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Adresy e-mail w tej grupie "), (_vm.meta.total) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("(" + _vm._s(_vm.meta.total) + ")")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      E-mail\n                  ")]), _vm._v(" "), _c('th', [_vm._v("\n                      Status\n                  ")]), _vm._v(" "), _c('th', [_vm._v("\n                      Zaimportowany\n                  ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.emails), function(email) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.emails.show',
            params: {
              id: email.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(email.email))])]), _vm._v(" "), _c('td', [(email) ? _c('email-status', {
      attrs: {
        "item": email
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(email.was_imported) ? _c('p', [_vm._v("\n                          Tak. " + _vm._s(email.imported_at_formated) + "\n                      ")]) : _vm._e(), _vm._v(" "), (!email.was_imported) ? _c('p', [_vm._v("\n                          Nie\n                      ")]) : _vm._e()])])
  }))]), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28198eca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email-groups/Show.vue
// module id = 235
// module chunks = 0